module.exports = __webpack_public_path__ + "static/game-95518c3157c1f6b57febdc83bde3c447.jpg";